import { LogDetailsModal } from '@/shared/components/LogDetailsModal';
import React from 'react';
import type { CatSubscription } from '../../types';

type Props = {
  catSubscription: CatSubscription | null;
  visible: boolean;
  onClose: () => void;
};

export const CatSubscriptionDetailsModal: React.FC<Props> = ({
  catSubscription,
  visible,
  onClose,
}) => {
  if (!catSubscription) return null;

  return (
    <LogDetailsModal
      visible={visible}
      onClose={onClose}
      title="Cat Subscription Raw Data"
      baseData={{
        id: catSubscription.id,
        createdAt: catSubscription.createdAt,
      }}
      additionalFields={[]}
      jsonSections={[
        {
          title: 'Raw Data',
          data: catSubscription,
        },
      ]}
    />
  );
};
